/**
 * Checks if the function is async
 * @param fn - function to be evaluated
 * @returns true if fn is an async function
 */

export const isAsync = (fn: Function) =>
  fn.constructor.name === 'AsyncFunction';

/**
 * Wraps an async function so that concurrent calls share the same in-flight
 * promise. Once the promise settles, the next call starts a new one.
 */
export function dedupeWhilePending<T, A extends unknown[]>(
  fn: (...args: A) => Promise<T>,
) {
  let pending: Promise<T> | null = null;

  return (...args: A) => {
    if (!pending) {
      pending = fn(...args).finally(() => {
        pending = null;
      });
    }
    return pending;
  };
}
